import './Counter.css'
import React from 'react'

import CountUp from 'react-countup'

export default ({ number, description }) => {
    const windowGlobal = typeof window !== 'undefined' && window

    return <div className='counter'>
        {number &&
            <CountUp
                start={0}
                end={Number(number)}
                duration={3}
                separator=','
            >
                {({ countUpRef, start }) => {
                    var activated = false

                    if(typeof windowGlobal.addEventListener === 'function') {
                        windowGlobal.addEventListener('scroll', () => {
                            if (countUpRef && countUpRef.current && countUpRef.current.getBoundingClientRect().top <= (windowGlobal.innerHeight / 1.5) && !activated) {
                                activated = true
                                start()
                            }
                        })
                    }
                
                    return <div>
                        <span ref={countUpRef} />
                    </div>
                }}
            </CountUp>
        }
        {description && <p>{description}</p>}
    </div>
}



// WEBPACK FOOTER //
// ./src/components/Counter.js